var ENGLISH_UNITS = "english";
var METRIC_UNITS = "metric";
var gUnits = ENGLISH_UNITS;

// start with stock project
var activeProject = new BeamProject(
  "Untitled Beam", new BeamFlexure(), new BeamFlexureDesign, null, null);
var designConfigurator = new DesignConfigurator();

function changeUnits(cssClassName, newUnitStr) {
    var i, elements = document.getElementsByClassName(cssClassName);
    for (i = 0; i < elements.length; i += 1) {
        elements.item(i).innerHTML = newUnitStr;
    }
}

function setUnits() {
    updateLoadTable();
    if (gUnits === ENGLISH_UNITS) {
        changeUnits('units-force', 'kips');
        changeUnits('units-force-per-length', 'kips/in');
        changeUnits('units-pressure', 'ksi');
        changeUnits('units-moment', 'kip-in');
        changeUnits('units-length', 'in');
    } else {
        changeUnits('units-force', 'kN');
        changeUnits('units-force-per-length', 'kN/m');
        changeUnits('units-pressure', 'kPa');
        changeUnits('units-moment', 'kN-m');
        changeUnits('units-length', 'm');
    }
}

function onEnglishUnitsClicked() {
    setEnglishUnits();
    doBeamFlexureDesign();
    RedrawCanvas();
}

function onMetricUnitsClicked() {
    setMetricUnits();
    doBeamFlexureDesign();
    RedrawCanvas();
}

function setEnglishUnits() {
    document.getElementById('units-selector').innerHTML = "English Units";
    gUnits = ENGLISH_UNITS;
    setUnits();
}

function setMetricUnits() {
    document.getElementById('units-selector').innerHTML = "Metric Units";
    gUnits = METRIC_UNITS;
    setUnits();
}

function rotateBeam0Degrees() {
    if(firebase.auth().currentUser === null) {
        openSignupModal();
        return;
    }

    activeProject.beam.crossSectionRotation = 0;
    configureShapeButton();
    RedrawCanvas();
    autoBeamFlexureDesign();
}

function rotateBeam90Degrees() {
    if(firebase.auth().currentUser === null) {
        openSignupModal();
        return;
    }

    activeProject.beam.crossSectionRotation = 90;
    configureShapeButton();
    RedrawCanvas();
    autoBeamFlexureDesign();
}

function setCrossSectionBeamRotationButton() {
    if(activeProject.beam.crossSectionRotation === 0) {
        document.getElementById("beam-rotation-0-degrees-button").className = "btn btn-primary";
        document.getElementById("beam-rotation-90-degrees-button").className = "btn btn-default";
    } else {
        document.getElementById("beam-rotation-0-degrees-button").className = "btn btn-default";
        document.getElementById("beam-rotation-90-degrees-button").className = "btn btn-primary";
    }
}

function openNewBeamDialog() {
    if(customerGate()) { return; }

    var user = firebase.auth().currentUser;

    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() !== null && snapshot.val().isPaying === true) {
            if(activeProject.isNewProject === true) {
                $('#modal-new-beam-dialog').modal('show');
            } else if(activeProject.isModified === false) {
                saveDesignAndStartNew();
            } else {
                // update button action to save and start new
                // load-project-confirm-button
                $("#load-project-confirm-button").attr("onclick", "saveDesignAndStartNew();");
                $('#modal-change-projects-dialog').modal('show');
            }
        } else {
            // we have a user but they still need to upgrade
            openFinishUpgradeModal();
            return;
        }
    });
}

function openFileExlporerDialog() {
    if(customerGate()) { return; }

    var user = firebase.auth().currentUser;

    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() !== null && snapshot.val().isPaying === true) {
            //file-explorer-table
            document.getElementById("file-explorer-table").innerHTML = "<em>Loading...</em>";
            openFileExplorerDialog();
        } else {
            // we have a user but they still need to upgrade
            openFinishUpgradeModal();
            return;
        }
    });
}

function openMakeCopyDialog() {
    if(customerGate()) { return; }

    var user = firebase.auth().currentUser;

    firebase.database().ref('/subscriptions/' + user.uid).once('value').then(function(snapshot) {
        if(snapshot.val() !== null && snapshot.val().isPaying === true) {
            if(activeProject.isModified === false) {
                makeCopyOfProject();
            } else {
                // update button action to save and start new
                // load-project-confirm-button
                $("#load-project-confirm-button").attr("onclick", "makeCopyOfProject();");
                $('#modal-change-projects-dialog').modal('show');
            }
        } else {
            // we have a user but they still need to upgrade
            openFinishUpgradeModal();
            return;
        }
    });

}

function printBeamDesign() {
    if(customerGate()) { return; }
    window.print();
}

function openDeleteProjectDialog() {
    if(customerGate()) { return; }
    $('#modal-delete-project-dialog').modal('show');
}

function openPrintPreferencesDialog() {
    if(customerGate()) { return; }

    updatePrintPreferencesDialogFields();

    $('#modal-print-preferences-dialog').modal('show');
}

function loadProjectClicked(uuid) {
    if(activeProject.isModified === false) {
        loadProject(uuid);
    } else {
        var loadProjectFunctionStr = "loadProject('" + uuid + "');";
        $("#load-project-confirm-button").attr("onclick", loadProjectFunctionStr);
        $('#modal-change-projects-dialog').modal('show');
    }
    ga('send', 'event', 'Project List', 'open', 'Open from Project List');
}

function configureMaterialButton() {
    $('#material-panel-text').html(activeProject.materialName);
}

function configureShapeButton() {
    var shape = activeProject.shape;
    var shapeIxString = activeProject.beam.crossSectionRotation === 0 ? activeProject.shapeIxString : activeProject.shapeIyString
    var html = activeProject.shapeName;
    if(activeProject.isEngineeredLumber === false) {
        html += " (" + shapeIxString + ")";
    }
    document.getElementById('shape-panel-text').innerHTML = html
    document.getElementById('active-project-shape').innerHTML = activeProject.shapeName
    if(isSteelShape(shape) && isHssRectangleShape(shape)) {
        // show our orientation buttons
        document.getElementById("beam-rotation-button-group").className = "btn-group btn-group-sm hidden-print";
    } else {
        document.getElementById("beam-rotation-button-group").className = "btn-group btn-group-sm hidden-print hidden";
    }

    if(activeProject.isCustom) {
        loadCustomShapesInputTable();
    } else {
        document.getElementById("use-custom-shape").checked = false;
    }
}

function configureDesignButton() {
    document.getElementById('design-panel-text').innerHTML = activeProject.designTypeStr
    document.getElementById('active-project-design-spec').innerHTML = activeProject.designTypeStr
}

function configureSpanButton() {
    $('#span-panel-text').html((activeProject.beam.spans.length === 1) ? "1 Span" : activeProject.beam.spans.length + " Spans");
}

function configureLoadButton() {
    var nLoads = activeProject.beam.totalNumberOfLoads;
    $('#load-panel-text').html((nLoads === 1) ? "1 Load" : nLoads + " Loads");
}

function configureBracingButton() {
    //var str = '<a href="#" onclick="openModalBracingDialog();"><i class="glyphicon glyphicon-screenshot"></i> ';
    let html = 'Continuous Bracing';
    if (activeProject.design.bracingType == 'continuous') {
        html = 'Continuous Bracing';
    } else if (activeProject.design.bracingType == 'equal') {
        html = 'Braced @ ' + showSmallLengthWithUnits(activeProject.design.getBraceSpacing());
    } else if (activeProject.design.bracingType == 'custom') {
        html = 'Custom Bracing';
    } else if (activeProject.design.bracingType == 'unbraced') {
        html = 'Unbraced';
    }
    document.getElementById('bracing-panel-text').innerHTML = html
}
